import { createFileRoute } from '@tanstack/react-router'
import RoyaltyMainContainer from 'Royalty/containers/RoyaltyMainContainer'

import { Guard } from './-guard'

export const Route = createFileRoute('/royalty')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <RoyaltyMainContainer />
        </Guard>
    ),
})
